export const COLUMNSFORMACION = [
    {
        header: 'Nombre',
        accessorKey: 'new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Título',
        accessorKey: 'new_titulo',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha egreso',
        accessorKey: 'new_fechaegreso',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Institución otorgante',
        accessorKey: '_new_universidad_value',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Validado',
        accessorKey: 'new_validado',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]